<template>
  <Dialog
      v-model="dialogVisibleTips"
      :title="$t('sys.team.info')"
      :width="'400'"
      :dialogVisible="dialogVisibleTips"
      :isHeadLine="false"
      @update:dialogVisible="close"
  >
    <template #content>
      <div class="inners_warning">
        <div><img
            src="data:image/png;base64,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"/>
        </div>
        <div style="font-size: 14px;margin: 20px 0px">{{ $t('sys.team.numwarn') }}</div>
      </div>
    </template>
    <template #footer>
      <div class="setting_center">
        <el-button size="small" @click="close">{{ $t('common.sss16') }}</el-button>
        <el-button size="small" type="primary" @click="toBuy">{{ $t('sys.team.bug') }}</el-button>
      </div>
    </template>
  </Dialog>
</template>

<script setup>
import Dialog from "@/components/Dialog.vue";
import {defineProps, ref, watch, defineEmits, onMounted, computed} from "vue";
import {useRouter} from "vue-router";
import {isEmpty} from "@/utils/mylodash";
import {useStore} from "vuex";

const router = useRouter()
const emit = defineEmits()
const dialogVisibleTips = ref(false)
const store = useStore()

const {value} = defineProps({
  value: {type: Boolean, default: false}
})

watch(() => value, (val) => {
  dialogVisibleTips.value = val;
}, {immediate: true})


const close = () => {
  emit("close")
}

const allProductList = computed(() => store.state.buystorage.allProductList)
const toBuy = () => {
  // 工位预警
  const findTarget = allProductList.value.find(item => item.productSort === 1)
  const {id, productSort} = findTarget
  router.push({path: '/personal/buystorage', query: {indexId: id, productSort: productSort, type: 1}})
}

onMounted(async () => {
  if (isEmpty(allProductList.value)) {
    await store.dispatch("buystorage/getMailProductListApis", 1)
  }
})
</script>

<style lang="less" scoped>
.inners_warning {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.setting_center {
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
}
</style>